export enum ButtonType {
    Filled = 'filled',
    Outline = 'outline',
    Light = 'light',
    Link = 'link'
}

export enum ButtonColor {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Red = 'red',
    Green = "green",
    Blue = 'blue',
    Orange = 'orange',
    Pink = 'pink',
    Purple = 'purple',
    PurpleLight = 'purple-light',
    White = 'white',
    Black = 'black',
}

export enum ButtonSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}